<template>
  <div
    :class="$style.Container"
    :style="{
      width: props.size + 'px',
      height: props.size + 'px',
    }"
  >
    <LazyImage
      :src="props.src"
      :style="{
        borderRadius: props.radius,
        overflow: 'hidden',
      }"
      :aspectRatio="1"
      :class="$style.Image"
    />

    <SwapOutlined
      :style="{
        fontSize: props.selectSize / 1.5 + 'px',
        width: props.selectSize + 'px',
        height: props.selectSize + 'px',
      }"
      v-if="ableSelect"
      :class="$style.Icon"
      @click="handleChange"
    />
  </div>
</template>

<script lang="ts" setup>
  import { computed } from 'vue';
  import LazyImage from '../LazyImage/index.vue';
  import { SwapOutlined } from '@ant-design/icons-vue';

  const props = defineProps({
    src: {
      type: String,
      default: '',
    },

    size: {
      type: Number,
      default: 120,
    },

    selectSize: {
      type: Number,
      default: 24,
    },

    radius: {
      type: String,
      default: '50%',
    },

    ableSelect: {
      type: Boolean,
      default: true,
    },

    type: {
      type: String,
      default: 'personal',
    },
  });

  const emits = defineEmits(['update:src']);

  const urls = computed(() => {
    if (props.type === 'personal') {
      return [
        'https://static.lingvisions.com/public/d795133aabb84039af39cbd1c6f7fe4d.png',
        'https://static.lingvisions.com/public/8204fc8f7e1c4d0cb13f028b972d85e2.png',
        'https://static.lingvisions.com/public/342680d12ec84777a64f605f0767eac9.png',
        'https://static.lingvisions.com/public/74634e869f644d0ea21eadc6590a7f41.png',
        'https://static.lingvisions.com/public/1b457d45d15c4910b5169adcb3e8da71.png',
        'https://static.lingvisions.com/public/ed22147f5b594f4c966e51a5b9a1ac08.png',
        'https://static.lingvisions.com/public/85ef1e50361e404998e7299e5b551f9c.png',
        'https://static.lingvisions.com/public/f91347f79d644be8a1e76761ed766e6b.png',
        'https://static.lingvisions.com/public/e2dae273459b4c00bbc251b9db26e9de.png',
        'https://static.lingvisions.com/public/7e50e311993045d584e21ed5d6b70c30.png',
        'https://static.lingvisions.com/public/160b499abdfe47c3b514893a9a4fc6c1.png',
        'https://static.lingvisions.com/public/e196f60440144a44a703209bdf5bdb3d.png',
        'https://static.lingvisions.com/public/1710f3cf8d8949529977f738b6574506.png',
        'https://static.lingvisions.com/public/c909a1f071874efea108623bcdba5a74.png',
        'https://static.lingvisions.com/public/eef3cf83ca8841ada94d4cbd0bcbc12c.png',
        'https://static.lingvisions.com/public/43f30aeca5a543fa8dd70b1341976b98.png',
        'https://static.lingvisions.com/public/53fee490a5aa4f2c99e2b90ee233c814.png',
        'https://static.lingvisions.com/public/70ada29bcd05496f8e3967aa0dc91ac9.png',
        'https://static.lingvisions.com/public/840842312b0042648560aa2c660ed642.png',
        'https://static.lingvisions.com/public/f7caff9d2e5c43e28eb5550c60ea1ca9.png',
        'https://static.lingvisions.com/public/a8940b2832cc4066a9ef796aad50bdd0.png',
        'https://static.lingvisions.com/public/b4aafebfc24b42bb82a04f1b11c4ab44.png',
        'https://static.lingvisions.com/public/4f661869cb4847678ffffa7219f8dff5.png',
        'https://static.lingvisions.com/public/15810b8b5828415185336fb55eb53d20.png',
      ];
    } else {
      return [
        'https://static.lingvisions.com/public/da4e460efa524e3c839a0886291725da.png',
        'https://static.lingvisions.com/public/95f6510b5cd340d190c73fe5bb2a9b5e.png',
        'https://static.lingvisions.com/public/c2071e9124034b028c3fb99ec6574fba.png',
        'https://static.lingvisions.com/public/1db858a8ff22445c9b868273e1d0c5cf.png',
        'https://static.lingvisions.com/public/62304b9867d2482999b88cb7c5b3ca14.png',
        'https://static.lingvisions.com/public/5b040acc16ef4735a660d69a9f50f739.png',
        'https://static.lingvisions.com/public/39675a518e4b41a8aa25876dfb33a435.png',
        'https://static.lingvisions.com/public/39675a518e4b41a8aa25876dfb33a435.png',
        'https://static.lingvisions.com/public/a6fc0380e8654e3da8010fe8b53b4fa8.png',
        'https://static.lingvisions.com/public/f7af27781c0343c1875cae826d41edbc.png',
        'https://static.lingvisions.com/public/23829c6a35684cc0811aed0a83d4899a.png',
        'https://static.lingvisions.com/public/3cfb7614bdb749f79eadd22a4e8b86b1.png',
        'https://static.lingvisions.com/public/68d080af9be247ecaac18ad56f697c2b.png',
        'https://static.lingvisions.com/public/11904ee13b174c5991cd3a66d8270377.png',
      ];
    }
  });

  let index = 0;

  function handleChange() {
    index++;
    emits('update:src', urls.value[index]);

    if (index === urls.value.length - 1) {
      index = -1;
    }
  }
</script>

<style lang="less" module>
  .Container {
    position: relative;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .Icon {
    color: rgba(255, 255, 255, 0.45);
    display: flex !important;
    align-items: center;
    justify-content: center;
    position: absolute;
    bottom: 0;
    right: 0;
    z-index: 2;
    border: 1px solid rgba(66, 66, 66, 1);
    border-radius: 50%;
    cursor: pointer;
    background-color: rgba(20, 20, 20, 1);
    transition: all 0.2s;

    &:hover {
      color: #d89614;
      border-color: #d89614;
    }
  }

  .Image {
    img {
      user-select: none;
    }
  }
</style>
